import React from 'react'
import { FormattedMessage } from 'react-intl'
import { call, select } from 'redux-saga/effects'
import {
  action as apiAction,
  getData as apiGetData
} from 'api/Api'
import taskStatus from './taskStatus'
import { AuthError } from '@kanbo/api'
import sweetalert from 'sweetalert2'

export default function * requestDownloadBoardTemplate (action) {
  const { template, name } = action.payload

  try {
    const { TaskId } = yield call(apiAction, 'CreateTemplateFile', {
      template
    })

    if (TaskId) {
      const { FileId } = yield taskStatus({
        taskId: TaskId,
        progressMessage: (
          <FormattedMessage
            id='BOARD_TEMPLATE_DOWNLOAD_PROGRESS_RUNNING'
            values={{
              name: <b>{name}</b>
            }}
          />
        ),
        completedMessage: (
          <FormattedMessage
            id='BOARD_TEMPLATE_DOWNLOAD_PROGRESS_COMPLETED'
            values={{
              name: <b>{name}</b>
            }}
          />
        ),
        failMessage: (
          <FormattedMessage
            id='BOARD_TEMPLATE_DOWNLOAD_PROGRESS_FAILED'
            values={{
              name: <b>{name}</b>
            }}
          />
        ),
      })

      const { DownloadUrl } = yield call(apiGetData, 'DownloadTemplateFile', {
        FileId
      })

      window.open(DownloadUrl, '_blank')
    }
  } catch (error) {
    if (error instanceof AuthError) {
      const state = yield select()

      try {
        yield call(sweetalert, {
          text: state.kanbo.locale.messages['DOCUMENTS_SOURCE_ACCESS_DENIED_ACTION_ERROR'],
          type: 'info'
        })
      } catch (e) {}
    } else {
      throw error
    }
  }
}
